/** Builds memoized option lists for the task form. */
import { useMemo } from 'react';
import { sortParentOptions } from '@/features/tasks/utils/ui/taskFormUtils';
import { translate } from '@/i18n/useT';

export const useTaskFormOptions = (
  projectDisplayMap,
  contextDisplayMap,
  personDisplayMap,
  allTasks,
) => {
  return useMemo(() => {
    const parentTaskOptions = [
      { id: null, title: translate('taskform.rootParent', 'Top level') },
    ];
    sortParentOptions(allTasks).forEach((t) =>
      parentTaskOptions.push({ id: t.id, title: t.title }),
    );
    return {
      projectOptions: Array.from(projectDisplayMap?.values() ?? []),
      contextOptions: Array.from(contextDisplayMap?.values() ?? []),
      personOptions: Array.from(personDisplayMap?.values() ?? []),
      parentTaskOptions,
    };
  }, [projectDisplayMap, contextDisplayMap, personDisplayMap, allTasks]);
};
